import { ButtonContained } from "components/button/CommonButton";
import { useState } from "react";
import { Typography } from "@mui/material";

export function ErrorFallback({ error, resetErrorBoundary }) {
  const [isHover, setIsHover] = useState(false);
  const [count, setCount] = useState(0);
  if (error.message?.indexOf("Loading chunk") !== -1 && error.message?.indexOf("failed") !== -1) {
    return (
      <div
        className={`max-w-full break-words flex justify-center items-center flex-col min-h-screen`}
      >
        <p className={`font-extrabold text-3xl`}>We have some update! Refresh page now</p>
        <Typography
          variant="title"
          sx={{ mt: 3, height: 36, display: isHover ? "" : "none" }}
          onMouseLeave={() => {
            setIsHover(false);
            setCount((c) => c + 1);
          }}
        >
          {count === 0 ? "Tự F5 đi bấm gì mà bấm" : count === 1 ? "Đã bảo tự F5 đi rồi mà" : ""}
          {count > 1 ? "Bị lừa rồi. Tự F5 đi" : ""}
        </Typography>
        <ButtonContained
          sx={{ mt: 3, display: isHover ? "none" : "" }}
          onMouseEnter={() => setIsHover(true)}
        >
          {count > 1 ? "Thôi bấm được rồi nè" : "Refresh now"}
        </ButtonContained>
      </div>
    );
  }
  return (
    <div
      className={`max-w-full break-words flex justify-center items-center flex-col min-h-screen`}
    >
      <img src={`/assets/images/oops.png`} alt={``} className={`w-1/3`} />
      <p className={`font-extrabold text-3xl`}>Something went wrong</p>
      <p className={`font-bold text-center mt-5 border-2 mx-5 p-5`}>{error.message}</p>
    </div>
  );
}
